var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractuaConTuComunidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;stroke-dasharray:1 12;}.a,.b{stroke:#f0f4f9;stroke-miterlimit:10;}.b{fill:#fdfffc;stroke-width:2px;}.c{fill:#7821a0;}.d{fill:#a4c2f7;}.e{fill:url(#a);}.f{fill:#7fabfa;}.g{fill:#d4e1f4;}.h{fill:#f1eaf4;}.i{fill:#fff;}.j{fill:#264ecc;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -2.277,
    y1: -7.726,
    x2: -2.275,
    y2: -7.723,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 21.721,
    cy: 21.721,
    r: 21.721
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128.121 -742.959)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.202 781.946)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M247.526,784.869v43.8H187.04v-43.8a2.092,2.092,0,0,1,2.086-2.085h56.315A2.091,2.091,0,0,1,247.526,784.869Z",
    transform: "translate(-187.04 -782.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M244.4,784.869v43.8H187.04v-43.8a2.092,2.092,0,0,1,2.086-2.085h53.186A2.092,2.092,0,0,1,244.4,784.869Z",
    transform: "translate(-187.04 -782.784)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 12.514,
    height: 11.472,
    transform: "translate(23.986 45.886)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 43.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M247.526,861.778v2.086a2.091,2.091,0,0,1-2.085,2.085H189.126a2.092,2.092,0,0,1-2.086-2.085v-2.086Z",
    transform: "translate(-187.04 -861.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M244.657,885.71v1.971H213.371V885.71a3.241,3.241,0,0,1,3.244-3.243h24.8a3.241,3.241,0,0,1,3.243,3.243Z",
    transform: "translate(-198.771 -870.995)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M237.171,865.54v11.472H224.656v-2.086h3.129v-7.3h-3.129V865.54Z",
    transform: "translate(-203.799 -819.653)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 43.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M244.4,861.778v2.086a2.092,2.092,0,0,1-2.086,2.085H189.126a2.092,2.092,0,0,1-2.086-2.085v-2.086Z",
    transform: "translate(-187.04 -861.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M241.529,885.71v1.971H213.371V885.71a3.241,3.241,0,0,1,3.244-3.243h21.671a3.24,3.24,0,0,1,3.243,3.243Z",
    transform: "translate(-198.771 -870.995)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.729 9.386)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M254.1,815.167a12.511,12.511,0,0,1-12.514,12.515v-5.215A7.3,7.3,0,0,0,246.746,810l3.692-3.692A12.476,12.476,0,0,1,254.1,815.167Z",
    transform: "translate(-229.069 -802.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M232.048,831.433v5.214a12.5,12.5,0,0,1-11.868-8.562l4.943-1.648A7.311,7.311,0,0,0,232.048,831.433Z",
    transform: "translate(-219.533 -811.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M231.529,799.711v5.214a7.294,7.294,0,0,0-6.925,9.6l-4.943,1.648a12.128,12.128,0,0,1-.647-3.952,12.512,12.512,0,0,1,12.515-12.515Z",
    transform: "translate(-219.014 -799.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M250.438,803.372l-3.692,3.692a7.275,7.275,0,0,0-5.162-2.138v-5.214A12.472,12.472,0,0,1,250.438,803.372Z",
    transform: "translate(-229.069 -799.711)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.171 4.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M269.8,791.35v6.257a1.043,1.043,0,0,0,1.043,1.042h1.042v4.172l5.215-4.172h2.085a1.043,1.043,0,0,0,1.043-1.042V791.35a1.043,1.043,0,0,0-1.043-1.043h-8.343A1.043,1.043,0,0,0,269.8,791.35Z",
    transform: "translate(-228.081 -790.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M204.992,791.35v6.257a1.043,1.043,0,0,1-1.042,1.042h-1.043v4.172l-5.214-4.172h-2.086a1.043,1.043,0,0,1-1.043-1.042V791.35a1.043,1.043,0,0,1,1.043-1.043h8.343A1.043,1.043,0,0,1,204.992,791.35Z",
    transform: "translate(-194.563 -790.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M269.8,843.157V836.9a1.043,1.043,0,0,1,1.043-1.043h1.042v-4.171l5.215,4.171h2.085a1.043,1.043,0,0,1,1.043,1.043v6.257a1.042,1.042,0,0,1-1.043,1.042h-8.343A1.042,1.042,0,0,1,269.8,843.157Z",
    transform: "translate(-228.081 -808.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M204.992,843.157V836.9a1.043,1.043,0,0,0-1.042-1.043h-1.043v-4.171l-5.214,4.171h-2.086a1.043,1.043,0,0,0-1.043,1.043v6.257a1.042,1.042,0,0,0,1.043,1.042h8.343A1.042,1.042,0,0,0,204.992,843.157Z",
    transform: "translate(-194.563 -808.742)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 3.129,
    height: 7.3,
    transform: "translate(23.986 47.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M190.168,828.67v-43.8a2.092,2.092,0,0,1,2.086-2.085h-3.128a2.092,2.092,0,0,0-2.086,2.085v43.8a2.092,2.092,0,0,0,2.086,2.085h3.128A2.092,2.092,0,0,1,190.168,828.67Z",
    transform: "translate(-187.04 -782.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M219.743,882.467h-3.128a3.239,3.239,0,0,0-3.243,3.243v1.971H216.5V885.71a3.24,3.24,0,0,1,3.243-3.243Z",
    transform: "translate(-198.771 -827.195)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.159 780.903)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M187.245,786.545v43.8h-2.086v-43.8Z",
    transform: "translate(-185.159 -783.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.208,801.8a1.1,1.1,0,0,0,.74-.3,1.057,1.057,0,0,0,0-1.481l-.156-.125a.755.755,0,0,0-.188-.094.658.658,0,0,0-.188-.063,1.54,1.54,0,0,0-.208-.021,1.1,1.1,0,0,0-.741.3,1.028,1.028,0,0,0,.344,1.7A1.044,1.044,0,0,0,186.208,801.8Z",
    transform: "translate(-185.165 -789.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M244.6,780.9H188.288a3.132,3.132,0,0,0-3.129,3.128V788.2a1.043,1.043,0,0,0,2.086,0v-4.171a1.043,1.043,0,0,1,1.042-1.042H244.6a1.043,1.043,0,0,1,1.042,1.042V824.7h-58.4V796.546a1.043,1.043,0,0,0-2.086,0v31.286a3.132,3.132,0,0,0,3.129,3.128h20.857v5.214h-5.1a4.286,4.286,0,0,0-4.281,4.282v1.976a1.042,1.042,0,0,0,1.043,1.043h31.286a1.043,1.043,0,0,0,1.043-1.043v-1.976a4.286,4.286,0,0,0-4.281-4.282h-5.1v-5.214H244.6a3.132,3.132,0,0,0,3.128-3.128v-43.8A3.131,3.131,0,0,0,244.6,780.9Zm-13.558,59.554v.933h-29.2v-.933a2.2,2.2,0,0,1,2.2-2.2H228.85A2.2,2.2,0,0,1,231.045,840.457Zm-9.386-4.282H211.231v-5.214H221.66Zm22.943-7.3H188.288a1.043,1.043,0,0,1-1.043-1.042v-1.043h58.4v1.043A1.044,1.044,0,0,1,244.6,828.875Z",
    transform: "translate(-185.159 -780.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M217.845,815.688a13.55,13.55,0,1,0,22.485-13.825c-.02-.023-.028-.053-.05-.075a.861.861,0,0,0-.075-.049,13.541,13.541,0,0,0-22.376,13.907l0,.016C217.835,815.672,217.842,815.679,217.845,815.688Zm2.34.288,2.989-1a8.353,8.353,0,0,0,6.472,4.67V822.8A11.49,11.49,0,0,1,220.186,815.977ZM235.8,804.8a8.291,8.291,0,0,0-4.064-1.688v-3.148a11.416,11.416,0,0,1,6.292,2.609Zm-5.107.325a6.257,6.257,0,1,1-6.257,6.257A6.257,6.257,0,0,1,230.689,805.123Zm1.042,17.676v-3.148a8.323,8.323,0,0,0,5.54-13.379l2.227-2.227a11.458,11.458,0,0,1-7.767,18.754Zm-2.085-22.838v3.148a8.328,8.328,0,0,0-7.139,9.9L219.53,814a11.423,11.423,0,0,1,10.116-14.036Z",
    transform: "translate(-199.403 -788.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M270.592,802.923a1.043,1.043,0,0,0,1.1-.125l4.929-3.943h1.72a2.088,2.088,0,0,0,2.086-2.086v-6.257a2.088,2.088,0,0,0-2.086-2.086H270a2.088,2.088,0,0,0-2.086,2.086v6.257A2.088,2.088,0,0,0,270,798.855v3.129A1.042,1.042,0,0,0,270.592,802.923ZM270,790.512h8.343v6.257h-2.085a1.045,1.045,0,0,0-.652.228l-3.52,2.816v-2a1.041,1.041,0,0,0-1.043-1.043H270v-6.257Z",
    transform: "translate(-222.029 -784.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M194.768,798.855h1.72l4.929,3.943a1.043,1.043,0,0,0,1.694-.815v-3.129a2.088,2.088,0,0,0,2.085-2.085v-6.257a2.088,2.088,0,0,0-2.085-2.086h-8.343a2.089,2.089,0,0,0-2.086,2.086v6.257A2.088,2.088,0,0,0,194.768,798.855Zm0-8.343h8.343v6.258h-1.043a1.042,1.042,0,0,0-1.043,1.043v2L197.5,797a1.043,1.043,0,0,0-.651-.228h-2.086Z",
    transform: "translate(-188.511 -784.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M267.915,842.318A2.089,2.089,0,0,0,270,844.4h8.343a2.088,2.088,0,0,0,2.086-2.086v-6.257a2.089,2.089,0,0,0-2.086-2.086h-1.72l-4.929-3.943a1.043,1.043,0,0,0-1.694.815v3.128a2.088,2.088,0,0,0-2.086,2.086v6.257ZM270,836.061h1.042a1.042,1.042,0,0,0,1.043-1.043v-2l3.52,2.816a1.046,1.046,0,0,0,.652.228h2.085v6.257H270Z",
    transform: "translate(-222.029 -802.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M192.682,842.319a2.089,2.089,0,0,0,2.086,2.086h8.343a2.088,2.088,0,0,0,2.085-2.086v-6.257a2.088,2.088,0,0,0-2.085-2.086v-3.128a1.043,1.043,0,0,0-1.694-.815l-4.929,3.943h-1.72a2.089,2.089,0,0,0-2.086,2.086Zm2.086-6.257h2.086a1.043,1.043,0,0,0,.651-.228l3.52-2.816v2a1.043,1.043,0,0,0,1.043,1.043h1.043v6.257h-8.343Z",
    transform: "translate(-188.511 -802.69)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractuaConTuComunidad);
export default __webpack_public_path__ + "static/media/interactua_con_tu_comunidad.ba331d0f915360074cb9e78602188c4e.svg";
export { ForwardRef as ReactComponent };